const supportConfig = {
  // Read an Announcement
  "/system/announcement.read": {
    protocol: "ws",
    resource: "/system/announcement",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "support",
  },
  // Read News
  "/system/news.read": {
    protocol: "ws",
    resource: "/system/news",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "support",
  },
  // Update Read News
  "/system/news/:id/read.update": {
    protocol: "ws",
    resource: "/system/news/:id/read",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params.updates }),
    action: null,
    mockSelector: "support",
  },
  // Read Panel state(orgs)
  "/orgs/:orgId/supportTokens/state.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/supportTokens/state",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "support.state",
  },
  // Read Panel state(ents/orgs)
  "/ents/:entId/orgs/:orgId/supportTokens/state.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/supportTokens/state",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "support.state",
  },
  // Read Panel state(orgs/sites)
  "/orgs/:orgId/sites/:siteId/supportTokens/state.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/supportTokens/state",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "support.state",
  },
  // Read Panel state(ents/orgs/sites)
  "/ents/:entId/orgs/:orgId/sites/:siteId/supportTokens/state.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/supportTokens/state",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "support.state",
  },
  // Read History(orgs)
  "/orgs/:orgId/supportTokens/history.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/supportTokens/history",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "support.history",
  },
  // Read History(ents/orgs)
  "/ents/:entId/orgs/:orgId/supportTokens/history.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/supportTokens/history",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "support.history",
  },
  // Read History(orgs/sites)
  "/orgs/:orgId/sites/:siteId/supportTokens/history.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/supportTokens/history",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "support.history",
  },
  // Read History(ents/orgs/sites)
  "/ents/:entId/orgs/:orgId/sites/:siteId/supportTokens/history.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/supportTokens/history",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "support.history",
  },
  // Create Org-level(orgs)
  "/orgs/:orgId/supportTokens.create": {
    protocol: "ws",
    resource: "/orgs/:orgId/supportTokens",
    restful: true,
    method: "create",
    buildParams: (params) => ({
      data: params.updates,
    }),
    action: null,
    mockSelector: "support.supportTokens",
  },
  // Create Org-level(ents/orgs)
  "/ents/:entId/orgs/:orgId/supportTokens.create": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/supportTokens",
    restful: true,
    method: "create",
    buildParams: (params) => ({
      data: params.updates,
    }),
    action: null,
    mockSelector: "support.supportTokens",
  },
  // Create site-level(orgs/sites)
  "/orgs/:orgId/sites/:siteId/supportTokens.create": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/supportTokens",
    restful: true,
    method: "create",
    buildParams: (params) => ({
      data: params.updates,
    }),
    action: null,
    mockSelector: "support.supportTokens",
  },
  // Create site-level(ents/orgs/sites)
  "/ents/:entId/orgs/:orgId/sites/:siteId/supportTokens.create": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/supportTokens",
    restful: true,
    method: "create",
    buildParams: (params) => ({
      data: params.updates,
    }),
    action: null,
    mockSelector: "support.supportTokens",
  },
  // Extension(orgs)
  "/orgs/:orgId/supportTokens/:supportTokenId/extension.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/supportTokens/:supportTokenId/extension",
    restful: true,
    method: "update",
    buildParams: (params) => ({
      data: params.updates,
    }),
    action: null,
    mockSelector: "support.extension",
  },
  // Extension(orgs/sites)
  "/orgs/:orgId/sites/:siteId/supportTokens/:supportTokenId/extension.update": {
    protocol: "ws",
    resource:
      "/orgs/:orgId/sites/:siteId/supportTokens/:supportTokenId/extension",
    restful: true,
    method: "update",
    buildParams: (params) => ({
      data: params.updates,
    }),
    action: null,
    mockSelector: "support.extension",
  },
  // Extension(ents/orgs)
  "/ents/:entId/orgs/:orgId/supportTokens/:supportTokenId/extension.update": {
    protocol: "ws",
    resource:
      "/ents/:entId/orgs/:orgId/supportTokens/:supportTokenId/extension",
    restful: true,
    method: "update",
    buildParams: (params) => ({
      data: params.updates,
    }),
    action: null,
    mockSelector: "support.extension",
  },
  // Extension(ents/orgs/sites)
  "/ents/:entId/orgs/:orgId/sites/:siteId/supportTokens/:supportTokenId/extension.update":
    {
      protocol: "ws",
      resource:
        "/ents/:entId/orgs/:orgId/sites/:siteId/supportTokens/:supportTokenId/extension",
      restful: true,
      method: "update",
      buildParams: (params) => ({
        data: params.updates,
      }),
      action: null,
      mockSelector: "support.extension",
    },
  // Revocation(orgs)
  "/orgs/:orgId/supportTokens/:supportTokenId/revocation.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/supportTokens/:supportTokenId/revocation",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params.updates }),
    action: null,
    mockSelector: "support.revocation",
  },
  // Revocation(orgs/sites)
  "/orgs/:orgId/sites/:siteId/supportTokens/:supportTokenId/revocation.update":
    {
      protocol: "ws",
      resource:
        "/orgs/:orgId/sites/:siteId/supportTokens/:supportTokenId/revocation",
      restful: true,
      method: "update",
      buildParams: (params) => ({ data: params.updates }),
      action: null,
      mockSelector: "support.revocation",
    },
  // Revocation(ents/orgs)
  "/ents/:entId/orgs/:orgId/supportTokens/:supportTokenId/revocation.update": {
    protocol: "ws",
    resource:
      "/ents/:entId/orgs/:orgId/supportTokens/:supportTokenId/revocation",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params.updates }),
    action: null,
    mockSelector: "support.revocation",
  },
  // Revocation(ents/orgs/sites)
  "/ents/:entId/orgs/:orgId/sites/:siteId/supportTokens/:supportTokenId/revocation.update":
    {
      protocol: "ws",
      resource:
        "/ents/:entId/orgs/:orgId/sites/:siteId/supportTokens/:supportTokenId/revocation",
      restful: true,
      method: "update",
      buildParams: (params) => ({ data: params.updates }),
      action: null,
      mockSelector: "support.revocation",
    },
  // Get active support badge data(ents/org)
  "/ents/:entId/orgs/:orgId/supportTokens/badges.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/supportTokens/badges",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "support.badges",
  },
  // Get active support badge data(org)
  "/orgs/:orgId/supportTokens/badges.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/supportTokens/badges",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "support.badges",
  },
  // List active support tokens currently held by the supporter.
  "/me/supportTokens/delegations.read": {
    protocol: "ws",
    resource: "/me/supportTokens/delegations",
    restful: true,
    method: "read",
    action: null,
    buildParams: null,
    mockSelector: "support.delegations",
  },
  // List ended support tokens recently handled by the logged-in supporter.
  "/me/supportTokens/history.read": {
    protocol: "ws",
    resource: "/me/supportTokens/history",
    restful: true,
    method: "read",
    action: null,
    buildParams: null,
    mockSelector: "support.meHistory",
  },
  // Validate a pasted plaintext support token and return preview information before accepting.
  "/me/supportTokens/preview.read": {
    protocol: "ws",
    resource: "/me/supportTokens/preview",
    restful: true,
    method: "read",
    action: null,
    buildParams: null,
    mockSelector: "support.preview",
  },
  // Update status
  "/me/supportTokens/:supportTokenId/status.update": {
    protocol: "ws",
    resource: "/me/supportTokens/:supportTokenId/status",
    restful: true,
    method: "update",
    action: null,
    buildParams: (params) => ({ data: params.updates }),
    mockSelector: "support.status",
  },
  // Read transferred
  "/me/supportTokens/transferred.read": {
    protocol: "ws",
    resource: "/me/supportTokens/transferred",
    restful: true,
    method: "read",
    action: null,
    buildParams: null,
    mockSelector: "support.transferred",
  },
   // Update transfer
  "/me/supportTokens/:supportTokenId/transfer.update": {
    protocol: "ws",
    resource: "/me/supportTokens/:supportTokenId/transfer",
    restful: true,
    method: "update",
    action: null,
    buildParams: (params) => ({ data: params.updates }),
    mockSelector: "support.transfer",
  },
};

export default supportConfig;
